/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';

import {folioListCommons} from './folio-commons';
import {FolioResource} from '../../components/api/resources/resource/folio.resource';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-folio-route-page',
  template: `
    <adn-folio-list-page
      *ngIf="listReady"
      [list]="list">
    </adn-folio-list-page>
  `
})
export class FolioRoutePageComponent implements OnInit {
  list: any = {};
  listReady = false;

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(FolioResource) private readonly Folio: any,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    folioListCommons(this.list, false, this.LocalNetworkProfile, this.LocalUserPermissions);

    this.adnListHelper.setUpList(this.list, this.Folio, false, 'fullFolioList', {
      baseTable: 'folio',
      afterFill: () => {
        folioListCommons(this.list, true, this.LocalNetworkProfile, this.LocalUserPermissions);
      }
    });
    this.listReady = true;
  }
}
